<template>
  <v-container class="px-0 py-0 mt-4">
    <h1>You don't have an internet connection</h1>
    <h5>Please check your internet connection.</h5>
  </v-container>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {

  },
  methods: {

  }
};
</script>

<style>
</style>
